// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"54e2d7ef","239":"d2115c35","732":"daea6d19"}[chunkId] + ".chunk.js";
};